
<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 科目" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
                    <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加科目</el-button>
					
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="科目" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索科目"></el-input>
						</el-form-item>
						

						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">

				</el-table-column>
			<!-- 	<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				<el-table-column align="center" width="60" prop="sort" label="排序">
				</el-table-column>
				
				<el-table-column align="center" prop="name" label="科目名稱">
				</el-table-column>

				<el-table-column align="center" prop="serial" label="編號">
				</el-table-column>

                <el-table-column align="center" prop="task_icon" label="科目任務圖標">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.task_icon" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column>

                <el-table-column align="center" prop="task_icon_ok" label="任務完成圖標">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.task_icon_ok" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="today_max" label="練習最大次數(每日)">
				</el-table-column>
		
				
				<el-table-column align="center" prop="create_time" width="200" label="創建時間">
				</el-table-column>
				
                <el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row)">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加科目':'修改科目'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'100px':'170px'" :label-position="layout.is_phone?'top':'left'">
			
                <el-form-item  label="科目任務圖標" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'5',cms_type:'1'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.icon" :src="form.icon" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

                <el-form-item  label="任務完成圖標" prop="icon_over" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'5',cms_type:'1'}"
					  :show-file-list="false"
					  :on-success="handleAvatarGifSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.icon_over" :src="form.icon_over" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				
				<el-form-item label="科目名稱" prop="name">
					<el-input type="text" v-model="form.name" 
					placeholder="科目名稱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
				<el-form-item label="科目編號" prop="serial">
					<el-input type="text" v-model="form.serial" 
					placeholder="科目編號" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
				<el-form-item label="排序" prop="sort">
					<el-input type="number" v-model="form.sort" 
					placeholder="排序" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="練習最大次數（每日）" prop="today_max">
					<el-input type="number" v-model="form.today_max" 
					placeholder="練習最大次數（每日）" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					name: [{
							required: true,
							message: "名稱不能為空",
							trigger: 'blur',
						},
					],
					
					
                    icon: [{
							required: true,
							message: "上傳科目任務圖標",
							trigger: 'blur',
						},
					
					],
                    icon_over: [{
							required: true,
							message: "上傳任務完成圖標",
							trigger: 'blur',
						},
					
					],
                    serial: [{
							required: true,
							message: "編號不能為空",
							trigger: 'blur',
						},
					],
					
					today_max: [
                        {
                            required: true,
                            message: '練習最大次數（每日）不能為空',
                            trigger: 'blur'
                        },
                        {
                            validator: (rule, value, callback) => {
                            if (value <= 0) {
                                callback(new Error('練習最大次數（每日）不能小於等於0'))
                            } else {
                                callback()
                            }
                            },
                            trigger: ['blur', 'change']
                        }
                    ]
					
					
				},
                fullscreenLoading: false,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					time: [],
				},
				model_title: 'Subject',
				auth_val: 'Subject',
				preUrl: "data/SubjectList", //列表地址
				delAllUrl: "data/delSubjectAll", //批量删除地址
				delUrl: "data/delSubject", //删除單条地址
                addUrl: "data/addSubject", //添加/修改地址
				tableData: [],
				form: {
					id: 0,
					name:'',
					serial:'',
					content:"",
					appoint_id:0,
					today_max:1,
					sort:0,
					type:1,
				},
				prop: 'sort',
				sort: 'ascending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				

			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			
		},
		methods: {
		
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					this.user_list = all.data.list
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.task_icon = res.encryption.data.list.url
				}
                this.fullscreenLoading.close();
			  },
            handleAvatarGifSuccess(res, file) {
				this.form.icon_over = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.task_icon_ok = res.encryption.data.list.url
				}
                this.fullscreenLoading.close();
			},
			
			  beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳图片大小不能超過 2MB!');
				}
                this.fullscreenLoading = this.$loading({
                    lock: true,
                    text: '正在上傳图片',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
              
				return isJPG && isLt2M;
			
			  },
			

			// 打开模态框
			openModel(e, type) {
                console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						name: e.name,
						today_max: e.today_max,
                        icon:e.task_icon,
                        serial:e.serial,
                        sort:e.sort,
                        icon_over:e.task_icon_ok,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						today_max: 1,
						name:'',
                        icon:'',
                        serial:'',
                        sort:'',
                        icon_over:'',
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name:'',
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			}
		}
	}
</script>

<style>
</style>
